import React, {FC, ReactNode} from 'react';

import {useAppDispatch, useAppSelector} from '../../../../helpers/appReduxHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {archiveSandboxConversationAsyncAction} from '../../../../store/data/conversations/sandboxConversationsActions';
import {getIsUserFirstGlobalAdmin} from '../../../../store/data/teammates/teammatesSelectors';
import {SandboxEducationTipCoordinator, useSandboxEndDemoHandler} from './sandboxEducationTipCoordinator';
import {StartSandboxEducationTip, WelcomeEducationTipV3} from './welcomeEducationTip';

/*
 * Props.
 */

interface WelcomeEducationTipCoordinatorProps {
  conversationId: number | undefined;
  isSandboxTeam: boolean;
  children: ReactNode;
}

/*
 * Component.
 */

export const WelcomeEducationTipCoordinator: FC<WelcomeEducationTipCoordinatorProps> = (props) => {
  const dispatch = useAppDispatch();
  const isFirstGlobalAdmin = useAppSelector(getIsUserFirstGlobalAdmin);
  const onEndDemo = useSandboxEndDemoHandler();

  const onSkipSandbox = () => {
    if (props.conversationId) {
      dispatch(archiveSandboxConversationAsyncAction(props.conversationId));
    }

    onEndDemo();
  };

  return (
    <SandboxEducationTipCoordinator
      conversationId={props.conversationId}
      scenario={SandboxScenariosEnum.SCENARIO3_ACT1}
      step="start-scenario-3-conversation-1"
      isEligible={props.isSandboxTeam}
      onEnd={onSkipSandbox}
      EducationTip={isFirstGlobalAdmin ? WelcomeEducationTipV3 : StartSandboxEducationTip}
    >
      {props.children}
    </SandboxEducationTipCoordinator>
  );
};
